const UserName = (props) => {
  return props.firstname + " " + props.lastname;
};

export default UserName;
